import { Box, Stack } from '@mui/material';
import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router';
import { useAccount } from 'wagmi';

import { AppPagination } from 'src/components/Pagination';
import { ProjectStageEnum } from 'src/global/enums/project.enum';
import { useGetProjectListQuery } from 'src/store/services/project.service';

import { PrimaryButton } from '../Buttons/PrimaryButton';
import { ProductionListTable } from './ProductionListTable';

export function ProductionNodeList() {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const { address } = useAccount();
  const nagivate = useNavigate();
  const { data, isLoading } = useGetProjectListQuery(
    {
      page,
      limit,
      state: { in: [ProjectStageEnum.PRODUCTION, ProjectStageEnum.DEPOSIT] },
      address: address as string,
    },
    {
      skip: !address,
    },
  );

  const nodeList = useMemo(() => data?.data || [], [data]);
  const total = useMemo(() => data?.meta?.total || 0, [data]);

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleChangePage = (_event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage + 1);
  };

  return (
    <Box width={'100%'}>
      <ProductionListTable nodeList={nodeList} isLoading={isLoading} page={page} limit={limit} />
      <Stack direction={'row'} justifyContent={'end'} marginTop={4} marginBottom={4}>
        <AppPagination
          sx={{
            border: 'none',
          }}
          count={total}
          page={page - 1}
          rowsPerPage={limit}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Stack>
      <Stack direction={'row'} justifyContent={'center'} marginTop={4} marginBottom={4}>
        <PrimaryButton
          onClick={() => nagivate('/core-sale/create')}
          sx={{
            fontSize: '16px',
            fontWeight: 500,
            lineHeight: '20px',
            color: 'white',
          }}>
          Create NFT Sale
        </PrimaryButton>
      </Stack>
    </Box>
  );
}
